import React, { useState } from 'react';
import styled from 'styled-components';
import Dropdown from 'components/dropdown/base/Dropdown';
import type { ChanelProductVariants, Option } from '../../shared/types';
import DropdownButton from '../DropdownButton/DropdownButton';
import DropdownContent from '../DropdownContent/DropdownContent';
import DropdownOption from '../DropdownOption';

const OptionsList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

const OptionsListItem = styled.li``;

export default function ChanelDropdown(props: ChanelProductVariants) {
    const { options, displayColorSwatches } = props;
    const [selectedOption, set] = useState<Option | undefined>(options.find((x) => x.isSelected));

    function onChange(option: Option) {
        set(option);
    }

    return (
        <Dropdown
            trigger={
                <DropdownButton
                    selectedOption={selectedOption || options[0]}
                    displayColorSwatches={displayColorSwatches}
                />
            }
        >
            <DropdownContent>
                <OptionsList>
                    {options.map((option) => (
                        <OptionsListItem key={option.linkAction.url}>
                            <DropdownOption linkAction={option.linkAction} onClick={() => onChange(option)}>
                                {option.label}
                            </DropdownOption>
                        </OptionsListItem>
                    ))}
                </OptionsList>
            </DropdownContent>
        </Dropdown>
    );
}
